import React from 'react';
import { Box, IconButton } from '@mui/material';
import FullscreenIcon from '../../icons/FullscreenIcon';
import * as Dialog from '@radix-ui/react-dialog';
import FullScreenVideo from '../FullScreenVideo';
import { SaagasImage } from '../../types/SaagasImage';

interface VideoTopActionBarProps {
  video: SaagasImage;
  viewMode?: 'grid' | 'list';
}

const VideoTopActionBar: React.FC<VideoTopActionBarProps> = ({
  video,
  viewMode = 'list',
}) => {
  // Dynamic sizes based on view mode
  const barHeight = viewMode === 'grid' ? '50px' : '80px';
  const barPadding = viewMode === 'grid' ? '0px 16px' : '0px 28px';

  return (
    <Box
      className="canvas-action-bar"
      onClick={(e) => e.stopPropagation()}
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexDirection: 'row',
        background: 'linear-gradient(to bottom, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.35) 40%, rgba(0,0,0,0.10) 75%, rgba(0,0,0,0.0) 100%)',
        height: barHeight,
        width: '100%',
        maxHeight: barHeight,
        maxWidth: '100%',
        minHeight: barHeight,
        minWidth: '100%',
        flexShrink: 0,
        padding: barPadding,
        flexGrow: 0,
        boxSizing: 'border-box',
        overflow: 'hidden',
        alignContent: 'center',
        '@media (max-width: 600px)': {
          padding: viewMode === 'grid' ? '4px 6px' : '6px 10px',
        },
      }}
    >
      {/* Right Control - Fullscreen */}
      <Box 
        sx={{ 
          flexShrink: 0, 
          zIndex: 101, 
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          alignContent: 'center',
          height: '100%',
        }}
      >
        <Dialog.Root>
          <Dialog.Trigger asChild>
            <IconButton
              size="small"
              onClick={(e) => e.stopPropagation()}
              sx={{
                color: 'white',
                bgcolor: 'transparent',
                padding: 0,
                width: '35px',
                height: '35px',
                minWidth: '35px',
                minHeight: '35px',
                maxWidth: '35px',
                maxHeight: '35px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.3)' },
                '& svg': {
                  width: viewMode === 'grid' ? '28px' : '30px',
                  height: viewMode === 'grid' ? '28px' : '30px',
                  display: 'block',
                },
              }}
            >
              <FullscreenIcon />
            </IconButton>
          </Dialog.Trigger>
          <Dialog.Portal>
            <FullScreenVideo id={video.id} url={video.url} />
          </Dialog.Portal>
        </Dialog.Root>
      </Box>
    </Box>
  );
};

export default VideoTopActionBar;

